// redux
import { applyMiddleware, createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// middlewares
import { subscriptionMiddleware } from './middleware/subscriptions'

// root reducer
import rootReducer from './root-reducer'

// perist config
const persistConfig = {
  key: 'WimedoApp', // storage name
  storage,
  blacklist: [ 'data', 'notifications', 'contests' ] // don't store data; get it from server instead
}

let middlewares = [
  subscriptionMiddleware
]

// create store
// rewrire createStore to ConfigStore

export const store = createStore(
  // add reducer
  persistReducer( persistConfig, rootReducer ),
  // inital state
  {},
  // add middleware
  applyMiddleware( ...middlewares )
)

export const persistor = persistStore( store )